module.exports = __webpack_public_path__ + "img/img65.21f9e5f2.svg";